import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as Constants from '../../constants';
import './ImageGallery.scss';
import { Modal, ModalBody, ModalFooter } from 'react-modal-bootstrap';

export default class ImageGallery extends Component {
  state = {
    currentImgIndex: 0,
    showModal: false,
  }

  componentWillReceiveProps(newProps) {
    const { globalAction } = newProps;
    switch (globalAction && globalAction.type) {
      case Constants.CLOSE_POPUP:
        this.setState({ showModal: false });
        break;
      case Constants.LEFT_ARROW:
        this.changeCurrentIndex(-1);
        break;
      case Constants.RIGHT_ARROW:
        this.changeCurrentIndex(1);
        break;
    }
  }

  changeCurrentIndex = (updateValue) => {
    const { currentImgIndex } = this.state;
    if (this.isIndexChangeAllowed(updateValue)) {
      this.setState({
        currentImgIndex: currentImgIndex + updateValue
      });
    }
  }

  isIndexChangeAllowed = (updateValue) => {
    const imageLength = this.props.images.length;
    const updatedIndex = this.state.currentImgIndex + updateValue;

    return (updatedIndex >= 0) && (updatedIndex < imageLength);
  }

  openModal = (index = 1) => {
    this.setState({
      showModal: true,
      currentImgIndex: index
    });
  }

  render() {
    const { onDelete, images } = this.props;
    const { currentImgIndex, showModal } = this.state;
    return (<div className="imageGallery">
      <Modal className="imageGalleryModal" isOpen={showModal} onRequestHide={() => this.setState({ showModal: false })}>
        <ModalBody>
          <div className="imageModalContainer">
            <img onClick={() => this.changeCurrentIndex(-1)} src={require('../../images/arrow_left_active.svg')} className={`arrowImg left ${this.isIndexChangeAllowed(-1) ? '' : 'disabled'}`} />
            {
              images[currentImgIndex].type.indexOf('application/pdf') !== -1 ?
              <object 
                  className="rxImg"
                  width="100%"
                  height="100%"
                  style={{pointerEvents: 'none'}}
                  data={images[currentImgIndex].url}
                  type="application/pdf">
              </object> :
              <img src={images[currentImgIndex].url} className="rxImg"/>
            }
            <img onClick={() => this.changeCurrentIndex(1)} src={require('../../images/arrow_right_active.svg')} className={`arrowImg right ${this.isIndexChangeAllowed(1) ? '' : 'disabled'}`} />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn modalCloseBtn" onClick={() => this.setState({ showModal: false })}>Close</button>
        </ModalFooter>
      </Modal>
      <div className="galleryContainer">
        {images.map(({ id, url, isExpired, type }, index) => (<div key={url} className="imageContainer">
          {onDelete && <div className="deleteIcon" onClick={() => onDelete(id)}>X</div>}
          { 
            type.indexOf('application/pdf') !== -1 ?
            <div className="galleryImage" onClick={() => this.openModal(index)}> 
              <object
                width="100%"
                height="100%"
                style={{pointerEvents: 'none'}}
                data={url}
                type="application/pdf"
              >
              </object> 
            </div>  :
            <img src={url} className="galleryImage" onClick={() => this.openModal(index)}/>
          }
          {Boolean(isExpired) && <div className="expiredLabel">Expired</div>}
        </div>))}
      </div>
    </div>);
  }
}

ImageGallery.propTypes = {
  images: PropTypes.array.isRequired,
  onDelete: PropTypes.func,
  globalAction: PropTypes.object,
};
